// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderDetailsDeliveryScheduleStyles } from "@eisinc/App/Components/OrderDetails/OrderDetailsDeliverySchedule";
import { OrderDetailsTableStyle } from "@eisinc/App/SharedStyles/OrderDetailsStyles";
import xScreen from "@eisinc/XDL/Utilities/xScreen";
import { css } from "styled-components";

orderDetailsDeliveryScheduleStyles.tableRowStyle = {
    css: css`
            &&&:hover,
            &&&:focus {
                background: transparent;
                cursor: unset;
            }
            @media print {
                &&& {
                    border: 0;
                    display: flex;
                    flex-direction: column;
                }
            }
            ${xScreen("lte", "md")} {
                display: flex;
                flex-direction: column;
                &:first-child {
                    padding: 20px 0;
                    border-top-width: 1px;
                    border-top-style: solid;
                }
                td {
                    height: 100%;
                    padding: 6px 0;
                }
            }
        `,
};
orderDetailsDeliveryScheduleStyles.tableCellStyle = {
    ...OrderDetailsTableStyle.tableCellStyle,
    css: css`
            height: 40px;
            border-bottom: 0;
        `,
};
orderDetailsDeliveryScheduleStyles.hiddenHeaderStyle = {
    ...OrderDetailsTableStyle.hiddenHeaderStyle,
};
orderDetailsDeliveryScheduleStyles.tableCellGridStyle = {
    ...OrderDetailsTableStyle.tableCellGridStyle,
};
orderDetailsDeliveryScheduleStyles.deliveryScheduleTableHeaderStyle = {
    ...OrderDetailsTableStyle.shippingDetailsTableHeaderStyle,
};
orderDetailsDeliveryScheduleStyles.tableHeaderStyle = {
    ...OrderDetailsTableStyle.tableHeaderStyle,
};